import { DialogContent, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUrlHelp } from "../../Store/Actions/ComunicadorActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});


const Onboarding = (props) => {
    const { setOpenMessage, data = null, updateDataLeitura, removeAppMessage, idDialog } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        if (!_.isUndefined(data) && !_.isNull(data) && _.isUndefined(data.url)) {
            dispatch(getUrlHelp(data.conteudo));
        }
    }, [data]);

    return (
        <React.Fragment>
            {!_.isUndefined(data) && !_.isNull(data) && !_.isUndefined(data.url) &&
                <XAPPDialog
                    id="Onboarding"
                    key={data.idmensagem}
                    open={idDialog === "onboarding"}
                    onClose={() => setOpenMessage()}
                    fullWidth
                    maxWidth={md.mobile() === null && md.tablet() === null ? "sm" : "md"}
                >
                    <div className="flex w-full pl-24 bg-white">
                        <div style={{ flex: 1 }} />
                        <XAPPButton
                            className="p-8 "
                            icon="close"
                            type="icon"
                            iconProps="text-24 text-black"
                            onClick={() => {
                                updateDataLeitura(data);
                                removeAppMessage(data.idmensagem);
                                setOpenMessage();
                            }}
                        />
                    </div>
                    <DialogContent className="bg-white p-0" style={{ height: md.mobile() === null && md.tablet() === null ? "50vh" : "40vh" }}>
                        <iframe
                            id={"iframe_" + data.idmensagem}
                            src={String(data.url).trim()}
                            width={"100%"}
                            height={"98%"}
                        ></iframe>
                    </DialogContent>
                </XAPPDialog>
            }
        </React.Fragment >
    );
};

export default withStyles(styles, { withTheme: true })(Onboarding);